import axios from 'axios';
import type {
  ConfirmationInstructions,
  AccessType,
} from '@bb/domain/dist/types/AppointmentConfig';
import type { SendDetailsDTO } from '@bb/domain/dist/types/dto/AppointmentController/sendDetails';

type SendDetails = {
  detailsType: 'confirm' | 'deny' | 'cancel' | 'deny_coop';
  appointmentId: string;
  body: {
    appointmentId?: string;
    message?: string;
    details?: {
      instructions?: ConfirmationInstructions;
      access?: AccessType;
      message?: string;
      cancelledBy?: string;
    };
    notify?: {
      text: boolean;
      email: boolean;
      office: boolean;
    };
  };
  isPending?: boolean;
};

const sendDetails = async ({
  detailsType,
  appointmentId,
  body,
  isPending = false,
}: SendDetails) => {
  const { data } = await axios.post<SendDetailsDTO>(
    `/appointments/send/${appointmentId}/${detailsType}`,
    {
      ...body,
      appointmentId,
      detailsType,
      isPending,
    },
  );
  return data;
};

export default sendDetails;
